import { render, staticRenderFns } from "./permission-menu.vue?vue&type=template&id=e9b6bcfe"
import script from "./permission-menu.vue?vue&type=script&lang=ts"
export * from "./permission-menu.vue?vue&type=script&lang=ts"
import style0 from "./permission-menu.vue?vue&type=style&index=0&id=e9b6bcfe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports